import { useLanguage } from "../../../../stores/LanguageStore";
import {
  Group,
  LoadingOverlay,
  Paper,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import "../PRM.scss";
import LeadSheet from "../prospect/sheet/LeadSheet";
import { useParams } from "react-router-dom";
import { IconAddressBook } from "@tabler/icons-react";
import { useProfileStore } from "../../../../stores/UserStore";
import LeadCreateMobile from "./LeadCreateMobile";
import LeadsBaseSelectorMobile from "./LeadsBaseSelectorMobile";
import ControllerMobile from "./Controllers/ControllerMobile";
import ContainerMobile from "./Container/ContainerMobile";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../stores/LeadsStore";
import { useEffect, useMemo } from "react";
import LeadSheetMobile from "../prospect/sheet/mobile/LeadSheetMobile";
import LeadSheetArrows from "../prospect/sheet/mobile/LeadSheetArrows";

const LeadsTrackingMobile = ({ loading }) => {
  const { userId } = useParams();
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const systemStatuses = useLeadsStore((s) => s.systemStatuses);
  const customStatuses = useLeadsStore((s) => s.customStatuses);
  const containers = useLeadsContainerStore((s) => s.containers);
  const setContainers = useLeadsContainerStore((s) => s.setContainers);
  const mobile_activeContainer = useLeadsStore((s) => s.mobile_activeContainer);
  const setMobile_activeContainer = useLeadsStore(
    (s) => s.setMobile_activeContainer
  );
  const reloadAll = useLeadsContainerStore((s) => s.reloadAll);
  const setReloadAll = useLeadsContainerStore((s) => s.setReloadAll);

  const container = useMemo(() => {
    if (mobile_activeContainer) {
      return containers.find((x) => x.id === mobile_activeContainer?.id);
    }
    return null;
  }, [containers, mobile_activeContainer]);

  useEffect(() => {
    let newContainers = [...systemStatuses, ...customStatuses].map((x, i) => {
      return {
        ...x,
        items: [],
        total: null,
        loading: true,
        nextPageUrl: null,
        sort: null,
        loadingNext: false,
      };
    });
    setContainers(newContainers.sort((a, b) => a?.sorting - b?.sorting));

    const actualContainer = newContainers.find((x) => x.id === "answerer");
    setMobile_activeContainer({
      ...actualContainer,
      loading: true,
      loaded: false,
    });
  }, [profile?.id]);

  useEffect(() => {
    if (reloadAll) {
      setReloadAll(false);

      setContainers(
        containers.map((x) => ({ ...x, loaded: false, loading: true }))
      );
    }
  }, [reloadAll]);

  return (
    <Stack gap={0} px={16}>
      <Paper mt={16} mb={16} component={Group} p={"sm"} gap={"md"}>
        <ThemeIcon size={"lg"} radius={"md"} variant="filled" color="primary">
          <IconAddressBook size={24} />
        </ThemeIcon>

        <Text fw={700} fz={20} mr={"auto"}>
          {lang.leads.title}
        </Text>

        <LeadsBaseSelectorMobile />

        <LeadCreateMobile
          disabled={userId ? parseInt(userId) !== profile.id : false}
        />
      </Paper>

      <Stack
        pos={"relative"}
        flex={"1 1 auto"}
        gap={"xs"}
        h={"calc(100vh - 144px)"}
      >
        {loading ? (
          <LoadingOverlay visible style={{ borderRadius: 12 }} />
        ) : (
          <>
            <ControllerMobile />

            {container && <ContainerMobile container={container} />}

            <LeadSheetMobile />

            <LeadSheetArrows />
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default LeadsTrackingMobile;
